import { labFlagBadge } from '../../utils/labFlags'

type LabFlagBadgeProps = {
  /** `rows[].flag` as saved by the backend; anything else renders nothing. */
  flag: unknown
  className?: string
}

/** H / L mark for the Flag column: red for critical, amber for high / low, nothing for normal or empty. */
export function LabFlagBadge({ flag, className = '' }: LabFlagBadgeProps) {
  const spec = labFlagBadge(flag)
  if (!spec) return null
  return (
    <span
      aria-label={spec.title}
      className={`inline-flex min-w-[24px] items-center justify-center rounded px-1.5 py-0.5 text-[11px] font-bold leading-none text-white ${className}`.trim()}
      data-flag={String(flag)}
      style={{ background: spec.color, printColorAdjust: 'exact', WebkitPrintColorAdjust: 'exact' }}
      title={spec.title}
    >
      {spec.label}
      {spec.critical ? (
        <span aria-hidden className="ml-0.5">
          !
        </span>
      ) : null}
    </span>
  )
}

export default LabFlagBadge
